angular.module('smart-table')
    .directive('stPaginationScroll', ['$timeout', function (timeout) {
        return {
            require: 'stTable',
            link: function (scope, element, attr, ctrl) {
                var itemByPage = parseInt(HandbookConfiguration.InfiniteScrollLoadSize);
                var pagination = ctrl.tableState().pagination;
                var lengthThreshold = 50;
                var timeThreshold = 400;
                var handler = function () {
                    //call next page
                    ctrl.slice(pagination.start + itemByPage, itemByPage);
                };
                var promise = null;
                var lastRemaining = 9999;

                //original: we get parent of element angular.element(element.parent());
                var container;
                var ieVersion = msieversion();
                if (ieVersion >= 7 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || isSafari()) {
                    if (!scope.$parent.vm.folderInformation || scope.$parent.vm.folderInformation.viewType == -1) {// standard;
						if (ieVersion <= 10){
							container = element.parents('.' + folderContent.scrollableTable + '').eq(0);
						} else {
							//container = angular.element(folderContent.gridDocumentsBody).eq(0);                        
							container = element.children().eq(1);
						}                        
                    } else {
                        //container = element.parents('.' + folderContent.scrollableTable + '').eq(0);
                        //container = angular.element('#' + folderContent.content + '').eq(0);
                        container = element.children().eq(1);
                    }
                } else {
                    container = element.children().eq(1);
                }
                
                container.bind('scroll', function () {
                    var remaining = container[0].scrollHeight - (container[0].clientHeight + container[0].scrollTop);

                    //if we have reached the threshold and we scroll down
                    if (remaining < lengthThreshold && (remaining - lastRemaining) < 0) {

                        //if there is already a timer running which has no expired yet we have to cancel it and restart the timer
                        if (promise !== null) {
                            timeout.cancel(promise);
                        }
                        promise = timeout(function () {
                            handler();

                            //scroll a bit up
                            //container[0].scrollTop -= 500;

                            promise = null;
                        }, timeThreshold);
                    }
                    lastRemaining = remaining;
                });
            }
        };
    }]);
